import { render } from "./OpinionList.vue?vue&type=template&id=21498a15"
import script from "./OpinionList.vue?vue&type=script&lang=js"
export * from "./OpinionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__